export const STANDARD_PRODUCT_PAYMENT_METHOD = 10;
export const STANDARD_PRODUCT_PAYMENT_TYPE = "direct";

export const PANEL_CATEGORY_CODE = "akoestischepanelen";
export const EINDPROFIEL_CATEGORY_CODE = "accessoireakoestischpaneel";
export const BASE_INCLUDED_PANELS = 3; // first N panels included in base assembly price
export const PANEL_WIDTH_IN_MM = 600;

export const MONTAGE_SERVICE_TYPE_CODE = "montageservice";

export const PANEL_SET_CODES = [
  "vgroefbeige",
  "vgroefzwart",
  "vgroefdonkerbruin",
  "vgroefgrijsblauw",
  "vgroefdonkerbeige",
];
